 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import ALST from '@/components/alst'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import UNTITLED318 from '@/components/Untitled318'
 import UNTITLED319 from '@/components/Untitled319'
 import UNTITLED320 from '@/components/Untitled320'
 import UNTITLED321 from '@/components/Untitled321'
 import UNTITLED322 from '@/components/Untitled322'
 import UNTITLED323 from '@/components/Untitled323'
 import UNTITLED324 from '@/components/Untitled324'
 import UNTITLED325 from '@/components/Untitled325'
 import UNTITLED326 from '@/components/Untitled326'
 import UNTITLED327 from '@/components/Untitled327'
 import UNTITLED328 from '@/components/Untitled328'
 import UNTITLED329 from '@/components/Untitled329'
 import UNTITLED330 from '@/components/Untitled330'
 import UNTITLED331 from '@/components/Untitled331'
 import UNTITLED332 from '@/components/Untitled332'
 import UNTITLED333 from '@/components/Untitled333'
 import UNTITLED334 from '@/components/Untitled334'
 import UNTITLED335 from '@/components/Untitled335'
 import UNTITLED336 from '@/components/Untitled336'
 import LOVE_2 from '@/components/love_2'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/alst",
 			"name" : "alst",
 			"component" : ALST
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Untitled318",
 			"name" : "Untitled318",
 			"component" : UNTITLED318
 		},
 		{
 			"path" : "/Untitled319",
 			"name" : "Untitled319",
 			"component" : UNTITLED319
 		},
 		{
 			"path" : "/Untitled320",
 			"name" : "Untitled320",
 			"component" : UNTITLED320
 		},
 		{
 			"path" : "/Untitled321",
 			"name" : "Untitled321",
 			"component" : UNTITLED321
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js